import React from "react";
import {defineBlock, useEditor, ChildrenBlock} from "@smartfire/wordpress-react";
import style from "./block.module.scss";
import { InnerBlocks } from '@wordpress/block-editor';

function Block(){
    const {isEditing} = useEditor();

    return <div className={style.block}> 
                <div className={isEditing && style.editStyle}>
                    { isEditing ? 
                        <InnerBlocks
                            templateLock={false}
                        />:
                        <ChildrenBlock/>
                    }
                </div>
            </div>
}

export default defineBlock({
    Block,
    setup: {
        title: "Bloc container",
        parent: ["smartfire/2-colonnes"],
        supports:{
            align: [ 'left', 'center', 'right', 'full' ],
        }
    },
});
